import {
  determineFullTradeData,
  returnAllTradeDetailsFromGenericParams,
  returnOPLegFormThisTrade,
  returnRPLegFromThisTrade,
} from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { determineCurrencySymbol } from "@/lib/currencySymbolHelper";
import { returnDecimalFormatting } from "@/lib/globalFormatterHelper";
import { ExecutionStrategy } from "@/lib/interfaces and Enums/InterfaceExecutionStrategy";
import tradeDataStore from "@/store/tradeDataStore";

export function returnExecutionFeeValueToRender(
  params: any,
  thisTrade: ExecutionStrategy,
): number | undefined {
  if (!thisTrade) {
    return;
  }
  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);

  const helperObject = {
    params,
    thisTrade,
    isOp,
    isER,
    isOutright,
    isLeg,
  };

  if (isOp) {
    //ER
    // No Return - Only on the ER as an outright.
    if (isLeg || isOutright) {
      const thisOPLeg = returnOPLegFormThisTrade(helperObject);
      if (!thisOPLeg) {
        return;
      }
      return thisOPLeg.executionFee;
    }
  } else {
    //RP
    //ER - Only on the ER as an outright.
    const thisRPLeg = returnRPLegFromThisTrade(helperObject);
    if (isLeg || isOutright) {
      if (!thisRPLeg) {
        return;
      }

      return thisRPLeg.executionFee;
    }
  }
  return undefined;
}

export function returnFeeValueFormatted(
  valueToRender: number | undefined,
): string | undefined {
  if (valueToRender || valueToRender == 0.0) {
    const adjustedFee = Math.abs(valueToRender);
    if (adjustedFee || adjustedFee == 0) {
      return returnDecimalFormatting(Number(adjustedFee), "$");
    }
  }
  return undefined;
}

const ExecutionFeeCellRenderer = (params: any) => {
  const fullTradeData = determineFullTradeData(params);
  const currentTradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    currentTradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;
  if (!thisTrade) return null;

  const { isOp, isOutright, isLeg, isER } =
    returnAllTradeDetailsFromGenericParams(params);
  const helperObject = { params, thisTrade, isOp, isER, isOutright, isLeg };
  const thisLeg = isOp
    ? returnOPLegFormThisTrade(helperObject)
    : returnRPLegFromThisTrade(helperObject);

  const currencySymbol = determineCurrencySymbol({
    thisTrade,
    thisLeg,
    isLeg,
    isER,
    isOutright,
  });

  const valueToRender = returnExecutionFeeValueToRender(params, thisTrade);

  const formattedValueToRender = returnFeeValueFormatted(valueToRender);

  return (
    <div>
      {formattedValueToRender && `${currencySymbol}${formattedValueToRender}`}
    </div>
  );
};

export default ExecutionFeeCellRenderer;
